<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">登录</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			login接口提供了登录FRM系统的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/login">https://skfrm.cn/APIV2/login</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
       <frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-value :propsTableData='frmReturnValueNew'></frm-Return-value>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"data":
		[
			{
				"project_id":"322",
				"project_name":"FRMtestzwcai"
			},
			{
				"project_id":"343",
				"project_name":"FRMtestzwcai1"
			}
		],
		"account_id":"468",
		"token":"5cdea075fb813c24c5dfa413d79c0c6d",
		"account_name":"testcaizhiwei"
	}
	失败：
	{
		"error_code":"1001",
		"error_msg":"账号被禁用"
	}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from '../../../../components/frmRequestParamsTable';
	import FrmReturnvalueTable from '../../../../components/frmReturnValueTableNew';
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,
			'frm-Return-value':FrmReturnvalueTable,
			'frm-Error-Code':FrmErrorCodeTable,
		},
		data(){
			return{
				isPathData:['FRM API-v2','账号登录','登录'],
				frmRequestParams:[
					{"require":"是","name":"account_name","type":"string","msg":"账号名称"},
					{"require":"是","name":"password","type":"string","msg":"账号密码"},
				],
				frmReturnValueNew:[
					{
						"Parameter":"error_code",
						"name":"string",
						"msg":"0 成功  1 失败",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"error_msg",
						"name":"string",
						"msg":"成功返回 success  失败返回 fail",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"account_id",
						"name":"string",
						"msg":"账号id",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"account_name",
						"name":"string",
						"msg":"账号名称",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"token",
						"name":"string",
						"msg":"token",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"项目详细信息列表",
						"rowspan":3,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"project_id   string      项目id",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"project_name   string      项目名",
					},
					
				],
				frmErrorCode:[
					{"Statuscode":"1006","errormessage":"账号已被禁用","msg":"账号已被禁用"},
					{"Statuscode":"1008","errormessage":"密码不正确","msg":"密码不正确"},
					{"Statuscode":"1118","errormessage":"账号名称不存在","msg":"账号名称不存在"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Accountlogin/Signin.vue